import { client } from 'app/http';

import { TPaymentMethod } from 'app/types/entities/TPaymentMethod';

export const getPaymentMethods = async (id: string): Promise<TPaymentMethod[]> => {
  const { data } = await client.get(`payment/billing-account/${id}/payment-methods`);
  return data;
};
